import React, { Suspense, lazy, useEffect } from "react";
import Sidebar from "../../Module/sidebar";
import {
  ResultPanelEmpSidebarData,
  ResultPanelSidebarData,
} from "../../Module/resultPanelSidebarData";
import Loading from "../../Component/Loading";
import { Navigate, Route, Routes, useNavigate } from "react-router";
import { useSelector } from "react-redux";
import CommonRoutes from "../Common/commonRoute";
import { useDispatch } from "react-redux";
import { Logout, setInitialState } from "../../Action/authAction";
import { showSuccessSnackbar } from "../../Action/snackbarAction";
import UserDataSearch from "../CXOPanel/userDataSearch";
import ImportStudent from "./importStudent";
import UpcomingInterview from "./upcomingInterview";
import ImportResultCompilation from "./importResultCompilation";
// Movements of Meeting (same pages as the other panels)
const MovementsOfMeeting = lazy(() =>
  import("../CategoryPanel/MovementsOfMeeting/movementsOfMeeting"),
);
const EditMovementsOfMeeting = lazy(() =>
  import("../CategoryPanel/MovementsOfMeeting/editMovementsOfMeeting"),
);
const StudentResult = lazy(() => import("../CategoryPanel/studentResult"));
const ResultCompilation = lazy(
  () => import("../CategoryPanel/resultCompilation"),
);
const ImportResult = lazy(() => import("./importResult"));
const NationalDutyUsers = lazy(() => import("./nationalDutyUsers"));
const QualificationOrRanksPrediction = lazy(
  () => import("./Ranksprediction/QualificationOrRanksPrediction"),
);
const RankMaster = lazy(() => import("./RankMaster/rankMaster"));

const ResultPanelDashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loginType, role, authToken } = useSelector((state) => ({
    designation: state.Auth?.userInfo?.designation,
    loginType: state.Auth?.loginType,
    role: state?.Auth?.userInfo?.role,
    authToken: state?.Auth?.authToken,
  }));

  useEffect(() => {
    if (!(role === "RESULT" && authToken)) {
      dispatch(setInitialState());
      navigate("/");
    }
  }, [role, dispatch, authToken]);
  return (
    <div className="AppBox">
      <Sidebar
        data={
          loginType === 2 ? ResultPanelEmpSidebarData : ResultPanelSidebarData
        }
      />
      <div className="dashboard">
        {
          <CommonRoutes
            loginType={loginType}
            defaultPage={<ResultCompilation />}
          >
            <Route path="resultCompilation" element={<ResultCompilation />} />
            <Route path="studentResult" element={<StudentResult />} />
            <Route path="importResult" element={<ImportResult />} />
            <Route path="userDataSearch" element={<UserDataSearch />} />
            <Route path="nationalDutyUsers" element={<NationalDutyUsers />} />
            <Route path="importStudent" element={<ImportStudent />} />
            <Route
              path="qualificationAndranksPrediction"
              element={<QualificationOrRanksPrediction />}
            />
            <Route path="addRankMaster" element={<RankMaster />} />
            <Route path="upcomingInterview" element={<UpcomingInterview />} />
            <Route
              path="importResultCompilation"
              element={<ImportResultCompilation />}
            />
            <Route path="movementsOfMeeting" element={<MovementsOfMeeting />} />
            <Route path="editMovementsOfMeeting" element={<EditMovementsOfMeeting />} />
          </CommonRoutes>
        }
      </div>
    </div>
  );
};
export default ResultPanelDashboard;
